import { useEffect } from 'react';
import { isWebView } from 'shared/constants/AppTypeConstants';

interface UseLaunchQueueOptions {
  onFilesReceived: (files: File[]) => void;
}

export function useLaunchQueue({ onFilesReceived }: UseLaunchQueueOptions) {
  useEffect(() => {
    if (isWebView) return;
    if (!window.launchQueue) return;

    window.launchQueue.setConsumer(async (launchParams) => {
      if (!launchParams.files.length) return;

      const files: File[] = [];

      for (const fileHandle of launchParams.files) {
        const file = await fileHandle.getFile();
        files.push(file);
      }

      if (files.length > 0) {
        onFilesReceived(files);
      }
    });
  }, [onFilesReceived]);
}
